import getDecorators from "inversify-inject-decorators";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import { KeyboardMappingService } from "../../services/keyboardmapping-service";
import { PartyDTO, PlayerCharacterDTO } from "../../shared/dtos";
import { DefaultVerticalMenu } from "../components/base-menu";
import { PlayerCharacterCard } from "../components/player-character-card/player-character-card";
import { GeometryService } from "../ui-services/geometry-ui-service";
import { ThemeManager } from "../design-system/theme-manager";
import { buildTextStyle } from "../utils/text-style";

const { lazyInject } = getDecorators(container);

export class PartyMenu extends DefaultVerticalMenu<PlayerCharacterCard> {
    private party: PartyDTO;
    private gold: number;
    private goldText: Phaser.GameObjects.Text | undefined;

    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    @lazyInject(TYPES.KeyboardMappingService)
    private keyboardMappingService: KeyboardMappingService;

    @lazyInject(TYPES.ThemeManager)
    private themeManager: ThemeManager;

    private MAX_CHARACTER_ON_SCREEN = 4;

    constructor(
        x: number,
        y: number,
        width: number,
        height: number,
        party: PartyDTO,
        gold: number,
        scene: Phaser.Scene
    ) {
        super(scene, x, y);

        this.party = party;
        this.gold = gold;
        this.bindEvents();

        const heightPerElem = height / this.MAX_CHARACTER_ON_SCREEN;
        party.characters.forEach((pc, index) => {
            this.addMenuItem(
                new PlayerCharacterCard(
                    1,
                    (heightPerElem + 1) * ((index * 1) / 2),
                    width - 3,
                    heightPerElem,
                    pc,
                    this.scene
                )
            );
        });

        console.log("Party Menu created with ", this.menuItems.length, " items.");
        if (this.menuItems && this.menuItems.length > 0) {
            this.menuItems[0].select();
        }
    }

    protected bindEvents() {
        super.bindEvents();
        const controls = this.keyboardMappingService.getKeyboardMapping("mikado");
        this.scene.input.keyboard.on("keydown-" + controls.cancelKey, () =>
            this.scene.scene.sleep()
        );
    }

    public selectedCharacter(): PlayerCharacterDTO {
        return this.party.characters[this.menuItemIndex];
    }

    public draw() {
        const graphics = this.scene.add.graphics();

        this.geometryService.initGraphicContext(graphics);

        const screenWidth = this.scene.physics.world.bounds.width;
        const screenHeight = this.scene.physics.world.bounds.height;

        this.geometryService.drawBox(0, 0, screenWidth, screenHeight - 50);

        //@ts-ignore
        const menu = this.scene.add.container();

        this.menuItems.forEach((pcCard) => menu.add(pcCard));

        // Display gold at the bottom of the screen
        const goldY = screenHeight - 40;
        if (this.gold != null) {
            this.goldText = this.scene.add.text(10, goldY, `Gold: ${this.gold}`, {
                ...buildTextStyle(this.themeManager, { fontSize: "18px" }),
            });
        }
    }

    public updateGold(newGold: number) {
        this.gold = newGold;
        if (this.goldText && newGold != null) {
            this.goldText.setText(`Gold: ${this.gold}`);
        }
    }

    public confirm() {}
}
